/* ============================================================
   SENÉA Botanique — Tiroir panier (interactions)
   Ajax Cart API Shopify : /cart.js, /cart/change.js, /cart/add.js.
   Ouverture : survol ou clic sur l'icône panier (.cartToggle / #cartToggle
   / [data-cart-drawer-open]). PAS d'ouverture auto à l'ajout au panier
   (le pop-up natif du thème s'en charge). Fermeture : X, overlay,
   Escape, avec focus trap + retour de focus.
   Fidèle au handoff "Botanique" : seuil 40 €, confirmation suppression,
   promo accordéon, cross-sell.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-senea-drawer]');
  if (!root) return;

  var THRESHOLD = parseInt(root.getAttribute('data-threshold'), 10) || 4000;
  var SHIP_COST = parseInt(root.getAttribute('data-ship-cost'), 10) || 490;
  var CART_URL = root.getAttribute('data-cart-url') || '/cart';
  var FREE_SHIP_ENABLED = true; /* certains pays n'ont pas de seuil de gratuité */

  /* ---------- I18N ----------
     Priorité 1 : chaînes rendues côté serveur (Liquid, filtre `| t`)
     exposées en data-attributes sur la racine du tiroir (locales
     Shopify natives).
     Priorité 2 : le site utilise GTranslate en mode sous-domaine
     (de.natureluxy-shop.com, en., it., …). Le proxy GTranslate supprime
     les attributs data-i18n-* et ne traduit pas le contenu injecté en
     JS : on embarque donc un dictionnaire pour les 14 langues publiées
     et on détecte la langue via le sous-domaine.
     Priorité 3 : français (langue principale de la boutique). */
  var GT_I18N = {
    en: { unitPriceSuffix: 'each', itemCountOne: 'item', itemCountOther: 'items', discount: 'Discount', discountWithTitle: 'Discount · {{ title }}', shippingFree: 'Free', shipBarFreeHtml: 'Great, <strong>free shipping</strong> unlocked!', shipBarRemainingHtml: 'Only <strong>{{ amount }}</strong> away from free shipping.', promoErrorEmpty: 'Enter a code.', promoChecking: 'Checking…', promoApplied: 'Code applied! −{{ amount }}', promoSavedNotValidated: 'Code saved — if valid, the discount will appear at checkout.', promoErrorGeneric: 'Error — please try again.' },
    de: { unitPriceSuffix: 'pro Stück', itemCountOne: 'Artikel', itemCountOther: 'Artikel', discount: 'Rabatt', discountWithTitle: 'Rabatt · {{ title }}', shippingFree: 'Kostenlos', shipBarFreeHtml: 'Super, der <strong>Versand ist kostenlos</strong>!', shipBarRemainingHtml: 'Nur noch <strong>{{ amount }}</strong> bis zum kostenlosen Versand.', promoErrorEmpty: 'Bitte Code eingeben.', promoChecking: 'Wird geprüft…', promoApplied: 'Code angewendet! −{{ amount }}', promoSavedNotValidated: 'Code gespeichert — falls gültig, erscheint der Rabatt beim Bezahlen.', promoErrorGeneric: 'Fehler — bitte erneut versuchen.' },
    es: { unitPriceSuffix: 'por unidad', itemCountOne: 'artículo', itemCountOther: 'artículos', discount: 'Descuento', discountWithTitle: 'Descuento · {{ title }}', shippingFree: 'Gratis', shipBarFreeHtml: '¡Genial, el <strong>envío es gratis</strong>!', shipBarRemainingHtml: 'Solo <strong>{{ amount }}</strong> más para el envío gratis.', promoErrorEmpty: 'Introduce un código.', promoChecking: 'Comprobando…', promoApplied: '¡Código aplicado! −{{ amount }}', promoSavedNotValidated: 'Código guardado — si es válido, el descuento aparecerá en el pago.', promoErrorGeneric: 'Error — inténtalo de nuevo.' },
    it: { unitPriceSuffix: 'cad.', itemCountOne: 'articolo', itemCountOther: 'articoli', discount: 'Sconto', discountWithTitle: 'Sconto · {{ title }}', shippingFree: 'Gratuita', shipBarFreeHtml: 'Ottimo, la <strong>spedizione è gratuita</strong>!', shipBarRemainingHtml: 'Solo <strong>{{ amount }}</strong> per la spedizione gratuita.', promoErrorEmpty: 'Inserisci un codice.', promoChecking: 'Verifica…', promoApplied: 'Codice applicato! −{{ amount }}', promoSavedNotValidated: 'Codice salvato — se valido, lo sconto apparirà al pagamento.', promoErrorGeneric: 'Errore — riprova.' },
    pt: { unitPriceSuffix: 'cada', itemCountOne: 'artigo', itemCountOther: 'artigos', discount: 'Desconto', discountWithTitle: 'Desconto · {{ title }}', shippingFree: 'Grátis', shipBarFreeHtml: 'Ótimo, o <strong>envio é grátis</strong>!', shipBarRemainingHtml: 'Apenas <strong>{{ amount }}</strong> para o envio grátis.', promoErrorEmpty: 'Insira um código.', promoChecking: 'A verificar…', promoApplied: 'Código aplicado! −{{ amount }}', promoSavedNotValidated: 'Código guardado — se for válido, o desconto aparecerá no pagamento.', promoErrorGeneric: 'Erro — tente novamente.' },
    nl: { unitPriceSuffix: 'per stuk', itemCountOne: 'artikel', itemCountOther: 'artikelen', discount: 'Korting', discountWithTitle: 'Korting · {{ title }}', shippingFree: 'Gratis', shipBarFreeHtml: 'Top, <strong>gratis verzending</strong>!', shipBarRemainingHtml: 'Nog <strong>{{ amount }}</strong> tot gratis verzending.', promoErrorEmpty: 'Voer een code in.', promoChecking: 'Controleren…', promoApplied: 'Code toegepast! −{{ amount }}', promoSavedNotValidated: 'Code opgeslagen — als deze geldig is, verschijnt de korting bij het afrekenen.', promoErrorGeneric: 'Fout — probeer opnieuw.' },
    da: { unitPriceSuffix: 'pr. stk.', itemCountOne: 'vare', itemCountOther: 'varer', discount: 'Rabat', discountWithTitle: 'Rabat · {{ title }}', shippingFree: 'Gratis', shipBarFreeHtml: 'Sådan, <strong>gratis fragt</strong>!', shipBarRemainingHtml: 'Kun <strong>{{ amount }}</strong> fra gratis fragt.', promoErrorEmpty: 'Indtast en kode.', promoChecking: 'Kontrollerer…', promoApplied: 'Koden er anvendt! −{{ amount }}', promoSavedNotValidated: 'Koden er gemt — hvis den er gyldig, vises rabatten ved betaling.', promoErrorGeneric: 'Fejl — prøv igen.' },
    sv: { unitPriceSuffix: 'per styck', itemCountOne: 'vara', itemCountOther: 'varor', discount: 'Rabatt', discountWithTitle: 'Rabatt · {{ title }}', shippingFree: 'Gratis', shipBarFreeHtml: 'Toppen, <strong>fri frakt</strong>!', shipBarRemainingHtml: 'Endast <strong>{{ amount }}</strong> kvar till fri frakt.', promoErrorEmpty: 'Ange en kod.', promoChecking: 'Kontrollerar…', promoApplied: 'Koden har använts! −{{ amount }}', promoSavedNotValidated: 'Koden är sparad — om den är giltig visas rabatten i kassan.', promoErrorGeneric: 'Fel — försök igen.' },
    no: { unitPriceSuffix: 'per stk.', itemCountOne: 'vare', itemCountOther: 'varer', discount: 'Rabatt', discountWithTitle: 'Rabatt · {{ title }}', shippingFree: 'Gratis', shipBarFreeHtml: 'Flott, <strong>gratis frakt</strong>!', shipBarRemainingHtml: 'Bare <strong>{{ amount }}</strong> igjen til gratis frakt.', promoErrorEmpty: 'Skriv inn en kode.', promoChecking: 'Sjekker…', promoApplied: 'Koden er brukt! −{{ amount }}', promoSavedNotValidated: 'Koden er lagret — hvis den er gyldig, vises rabatten i kassen.', promoErrorGeneric: 'Feil — prøv igjen.' },
    fi: { unitPriceSuffix: 'kpl', itemCountOne: 'tuote', itemCountOther: 'tuotetta', discount: 'Alennus', discountWithTitle: 'Alennus · {{ title }}', shippingFree: 'Ilmainen', shipBarFreeHtml: 'Hienoa, <strong>ilmainen toimitus</strong>!', shipBarRemainingHtml: 'Enää <strong>{{ amount }}</strong> ilmaiseen toimitukseen.', promoErrorEmpty: 'Syötä koodi.', promoChecking: 'Tarkistetaan…', promoApplied: 'Koodi käytetty! −{{ amount }}', promoSavedNotValidated: 'Koodi tallennettu — jos se on voimassa, alennus näkyy kassalla.', promoErrorGeneric: 'Virhe — yritä uudelleen.' },
    pl: { unitPriceSuffix: 'za sztukę', itemCountOne: 'produkt', itemCountOther: 'produkty', discount: 'Rabat', discountWithTitle: 'Rabat · {{ title }}', shippingFree: 'Gratis', shipBarFreeHtml: 'Świetnie, <strong>darmowa dostawa</strong>!', shipBarRemainingHtml: 'Jeszcze tylko <strong>{{ amount }}</strong> do darmowej dostawy.', promoErrorEmpty: 'Wpisz kod.', promoChecking: 'Sprawdzanie…', promoApplied: 'Kod zastosowany! −{{ amount }}', promoSavedNotValidated: 'Kod zapisany — jeśli jest ważny, rabat pojawi się przy płatności.', promoErrorGeneric: 'Błąd — spróbuj ponownie.' },
    el: { unitPriceSuffix: 'ανά τεμάχιο', itemCountOne: 'προϊόν', itemCountOther: 'προϊόντα', discount: 'Έκπτωση', discountWithTitle: 'Έκπτωση · {{ title }}', shippingFree: 'Δωρεάν', shipBarFreeHtml: 'Τέλεια, <strong>δωρεάν αποστολή</strong>!', shipBarRemainingHtml: 'Μόνο <strong>{{ amount }}</strong> ακόμη για δωρεάν αποστολή.', promoErrorEmpty: 'Εισάγετε κωδικό.', promoChecking: 'Έλεγχος…', promoApplied: 'Ο κωδικός εφαρμόστηκε! −{{ amount }}', promoSavedNotValidated: 'Ο κωδικός αποθηκεύτηκε — αν είναι έγκυρος, η έκπτωση θα εμφανιστεί στο ταμείο.', promoErrorGeneric: 'Σφάλμα — δοκιμάστε ξανά.' },
    ga: { unitPriceSuffix: 'an ceann', itemCountOne: 'earra', itemCountOther: 'earraí', discount: 'Lascaine', discountWithTitle: 'Lascaine · {{ title }}', shippingFree: 'Saor in aisce', shipBarFreeHtml: 'Iontach, <strong>seachadadh saor in aisce</strong>!', shipBarRemainingHtml: 'Níl ach <strong>{{ amount }}</strong> fágtha le haghaidh seachadadh saor in aisce.', promoErrorEmpty: 'Cuir cód isteach.', promoChecking: 'Á sheiceáil…', promoApplied: 'Cód curtha i bhfeidhm! −{{ amount }}', promoSavedNotValidated: 'Cód sábháilte — má tá sé bailí, taispeánfar an lascaine ag an íocaíocht.', promoErrorGeneric: 'Earráid — bain triail eile as.' }
  };
  /* Langue GTranslate = premier label du hostname (ex. de.natureluxy-shop.com).
     La langue principale (fr) et le domaine nu ne matchent pas → français. */
  function detectGtLang() {
    try {
      var sub = (window.location.hostname || '').split('.')[0].toLowerCase();
      return Object.prototype.hasOwnProperty.call(GT_I18N, sub) ? sub : null;
    } catch (e) { return null; }
  }
  var GT_LANG = detectGtLang();

  /* ---------- Frais de livraison par langue/pays ----------
     Source : zones d'expédition Shopify (Admin API, profil « General »).
     threshold = seuil de livraison offerte en centimes (null si aucune
     gratuité pour ce pays) ; cost = tarif le moins cher en centimes
     (point relais, ou 1er palier de poids pour les zones au poids).
       fr (défaut) → FRANCE (FR/BE)      : offerte ≥ 29 €, sinon 3,58 €
       de          → Allemagne (DE)      : offerte ≥ 29 €, sinon 4,90 €
       es          → Espagne (ES)        : offerte ≥ 29 €, sinon 5,90 €
       it          → Italie (IT)         : offerte ≥ 29 €, sinon 5,90 €
       pt/nl/pl    → Shop2shop Europe    : dès 12,90 € (au poids, pas de gratuité)
       da/sv       → Danemark/Suède      : 9,90 € (pas de gratuité)
       fi/el       → Finlande/Grèce      : dès 11,90 € (au poids, pas de gratuité)
       no          → Norvège             : dès 28,90 € (au poids, pas de gratuité)
       en/ga       → Irlande (zone Europe) : dès 19,90 € (au poids, pas de gratuité) */
  var GT_SHIP = {
    de: { threshold: 2900, cost: 490 },
    es: { threshold: 2900, cost: 590 },
    it: { threshold: 2900, cost: 590 },
    pt: { threshold: null, cost: 1290 },
    nl: { threshold: null, cost: 1290 },
    pl: { threshold: null, cost: 1290 },
    da: { threshold: null, cost: 990 },
    sv: { threshold: null, cost: 990 },
    fi: { threshold: null, cost: 1190 },
    el: { threshold: null, cost: 1190 },
    no: { threshold: null, cost: 2890 },
    en: { threshold: null, cost: 1990 },
    ga: { threshold: null, cost: 1990 }
  };
  if (GT_LANG && GT_SHIP[GT_LANG]) {
    SHIP_COST = GT_SHIP[GT_LANG].cost;
    if (GT_SHIP[GT_LANG].threshold === null) {
      FREE_SHIP_ENABLED = false;      /* pas de barre « livraison offerte » */
    } else {
      THRESHOLD = GT_SHIP[GT_LANG].threshold;
    }
  }
  function attr(name, key, fallback) {
    /* Sur un sous-domaine GTranslate (de., en., it., …), la page proxifiée
       est la page source FRANÇAISE : GTranslate traduit le texte visible
       mais PAS les valeurs des attributs data-*. Les data-i18n-* arrivent
       donc toujours en français → le dictionnaire embarqué doit être
       prioritaire sur les attributs dans ce cas. */
    if (GT_LANG && GT_I18N[GT_LANG] && GT_I18N[GT_LANG][key]) {
      return GT_I18N[GT_LANG][key];
    }
    var v = root.getAttribute(name);                            /* locales Shopify natives */
    if (v !== null && v !== '') return v;
    return fallback;                                            /* français par défaut */
  }
  var I18N = {
    unitPriceSuffix: attr('data-i18n-unit-price-suffix', 'unitPriceSuffix', 'l\u2019unité'),
    itemCountOne: attr('data-i18n-item-count-one', 'itemCountOne', 'article'),
    itemCountOther: attr('data-i18n-item-count-other', 'itemCountOther', 'articles'),
    discount: attr('data-i18n-discount', 'discount', 'Réduction'),
    discountWithTitle: attr('data-i18n-discount-with-title', 'discountWithTitle', 'Réduction · {{ title }}'),
    shippingFree: attr('data-i18n-shipping-free', 'shippingFree', 'Offerte'),
    shipBarFreeHtml: attr('data-i18n-ship-bar-free-html', 'shipBarFreeHtml', 'Bravo, la <strong>livraison est offerte</strong> !'),
    shipBarRemainingHtml: attr('data-i18n-ship-bar-remaining-html', 'shipBarRemainingHtml', 'Plus que <strong>{{ amount }}</strong> pour la livraison offerte.'),
    promoErrorEmpty: attr('data-i18n-promo-error-empty', 'promoErrorEmpty', 'Saisissez un code.'),
    promoChecking: attr('data-i18n-promo-checking', 'promoChecking', 'Vérification…'),
    promoApplied: attr('data-i18n-promo-applied', 'promoApplied', 'Code appliqué ! −{{ amount }}'),
    promoSavedNotValidated: attr('data-i18n-promo-saved-not-validated', 'promoSavedNotValidated', 'Code enregistré — s’il est valide, la remise apparaîtra au paiement.'),
    promoErrorGeneric: attr('data-i18n-promo-error-generic', 'promoErrorGeneric', 'Erreur — réessayez.')
  };
  /* Remplace les jetons {{ xxx }} d'une chaîne traduite par les valeurs fournies. */
  function t(str, vars) {
    if (!vars) return str;
    return str.replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, function (m, key) {
      return Object.prototype.hasOwnProperty.call(vars, key) ? vars[key] : m;
    });
  }
  function itemCountLabel(count) {
    return count > 1 ? I18N.itemCountOther : I18N.itemCountOne;
  }

  var panel = root.querySelector('[data-drawer-panel]');
  var linesEl = root.querySelector('[data-drawer-lines]');
  var emptyEl = root.querySelector('[data-drawer-empty]');
  var crossEl = root.querySelector('[data-drawer-cross]');
  var promoEl = root.querySelector('[data-drawer-promo]');
  var footEl = root.querySelector('[data-drawer-foot]');
  var shipEl = root.querySelector('[data-ship-bar]');
  var countEl = root.querySelector('[data-drawer-count]');
  var tpl = document.querySelector('[data-line-template]');
  var lastFocus = null;
  var cachedCart = null; // dernier panier connu : permet un affichage instantané à l'ouverture

  /* ---------- Format prix FR (virgule + espace insécable + €) ---------- */
  function money(cents) {
    return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '\u00A0€';
  }

  function analytics(name, payload) {
    try { document.dispatchEvent(new CustomEvent('senea:analytics', { detail: { name: name, payload: payload } })); } catch (e) {}
  }

  /* ---------- Cart API ---------- */
  function getCart() {
    return fetch(CART_URL + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/change ' + r.status);
      return r.json();
    });
  }

  /* Séquence globale : permet d'ignorer les réponses obsolètes lorsque
     plusieurs requêtes de quantité se chevauchent (clics rapides +/−). */
  var qtySeq = 0;
  function isValidCart(cart) {
    return cart && typeof cart.item_count === 'number' && Array.isArray(cart.items);
  }
  function safeRender(cart) {
    if (isValidCart(cart)) { render(cart); }
    else { getCart().then(render); } // réponse invalide → on resynchronise
  }
  function cacheCart(cart) { if (isValidCart(cart)) cachedCart = cart; }
  function addVariant(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) { return r.json(); });
  }

  /* ---------- Rendu ---------- */
  function render(cart) {
    if (!isValidCart(cart)) return; // garde-fou : jamais de « undefined article »
    cachedCart = cart; // mémorise pour un affichage instantané à la prochaine ouverture
    var count = cart.item_count;
    if (countEl) countEl.textContent = count + ' ' + itemCountLabel(count);
    bumpHeaderCount(count);

    var isEmpty = count === 0;
    if (emptyEl) emptyEl.hidden = !isEmpty;
    if (shipEl) shipEl.hidden = isEmpty || !FREE_SHIP_ENABLED;
    if (footEl) footEl.hidden = isEmpty;
    if (crossEl) crossEl.hidden = isEmpty;
    if (promoEl) promoEl.hidden = isEmpty;
    linesEl.hidden = isEmpty;

    // Lignes
    linesEl.innerHTML = '';
    cart.items.forEach(function (item) {
      var node = tpl.content.firstElementChild.cloneNode(true);
      node.setAttribute('data-item-key', item.key);

      var img = node.querySelector('[data-item-img]');
      if (item.image) {
        var im = document.createElement('img');
        im.src = item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2');
        im.alt = item.product_title || '';
        im.loading = 'lazy';
        img.appendChild(im);
      }

      var name = node.querySelector('[data-item-name]');
      name.textContent = item.product_title;
      name.href = item.url;

      var sub = node.querySelector('[data-item-sub]');
      // sous-titre : variante uniquement (hors Default Title) — type produit masqué
      var subParts = [];
      if (item.variant_title && item.variant_title.indexOf('Default') === -1) {
        subParts.push('<span class="sd-item-variant">' + escapeHtml(item.variant_title) + '</span>');
      }
      sub.innerHTML = subParts.join(' · ');

      var tagsEl = node.querySelector('[data-item-tags]');
      (item.options_with_values || []).slice(0, 0); // (réservé) — tags via product.tags non dispo dans cart.js
      if (item.properties && item.properties._tags) {
        String(item.properties._tags).split(',').slice(0, 3).forEach(function (tag) {
          var s = document.createElement('span'); s.textContent = tag.trim(); tagsEl.appendChild(s);
        });
      }

      var val = node.querySelector('[data-qty-val]');
      val.textContent = item.quantity;
      var dec = node.querySelector('[data-qty-dec]');
      if (dec) dec.disabled = item.quantity <= 1;

      node.querySelector('[data-item-total]').textContent = money(item.final_line_price);
      node.querySelector('[data-item-unit]').textContent = money(item.final_price) + ' ' + I18N.unitPriceSuffix;

      wireLine(node, item);
      linesEl.appendChild(node);
    });

    renderTotals(cart);
    renderShip(cart);
  }

  function renderTotals(cart) {
    setText('[data-total-subtotal]', money(cart.items_subtotal_price));

    var total = cart.total_price;
    var free = FREE_SHIP_ENABLED && total >= THRESHOLD;
    var shipRow = root.querySelector('[data-total-shipping-row]');
    if (shipRow) {
      shipRow.hidden = false;
      setText('[data-total-shipping]', free ? I18N.shippingFree : money(SHIP_COST));
    }

    // remises natives — panier (cart-level) ET lignes de produits (line-level)
    var discRow = root.querySelector('[data-total-discount-row]');
    if (discRow) {
      var d = getDiscountInfo(cart);
      if (d.amount > 0) {
        discRow.hidden = false;
        setText('[data-discount-label]', d.title ? t(I18N.discountWithTitle, { title: d.title }) : I18N.discount);
        setText('[data-total-discount]', '-' + money(d.amount));
      } else {
        discRow.hidden = true;
      }
    }

    // total affiché = total Shopify + livraison estimée si sous le seuil
    var displayTotal = free ? total : total + SHIP_COST;
    setText('[data-total-total]', money(displayTotal));
  }

  function renderShip(cart) {
    if (!shipEl) return;
    /* Pays sans seuil de gratuité (zones au poids/sans offre) : la barre
       « Plus que X € pour la livraison offerte » n'a pas de sens → masquée. */
    if (!FREE_SHIP_ENABLED) { shipEl.hidden = true; return; }
    var total = cart.total_price;
    var free = total >= THRESHOLD;
    var pct = Math.min(100, Math.round((total / THRESHOLD) * 100));
    var fill = shipEl.querySelector('[data-ship-fill]');
    var txt = shipEl.querySelector('[data-ship-txt]');
    if (fill) fill.style.width = pct + '%';
    if (txt) {
      if (free) {
        txt.innerHTML = I18N.shipBarFreeHtml;
      } else {
        txt.innerHTML = t(I18N.shipBarRemainingHtml, { amount: money(THRESHOLD - total) });
      }
    }
  }

  /* Agrège les remises : cart-level (codes panier) + line-level (codes
     appliqués aux produits, ex. PROMO35 sur des collections). */
  function getDiscountInfo(cart) {
    var amount = 0, title = '';
    (cart.cart_level_discount_applications || []).forEach(function (a) {
      amount += a.total_allocated_amount || 0;
      if (!title) title = a.title || '';
    });
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (a) {
        amount += a.amount || 0;
        if (!title && a.discount_application) title = a.discount_application.title || '';
      });
    });
    // filet de sécurité : total_discount du panier si rien détecté
    if (amount === 0 && cart.total_discount > 0) amount = cart.total_discount;
    return { amount: amount, title: title };
  }

  function setText(sel, t) { var el = root.querySelector(sel); if (el) el.textContent = t; }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function bumpHeaderCount(n) {
    document.querySelectorAll('[data-cart-count], .cart-count, .senea-cart-count, #cartCount, .cartCount, #sene-cart-count, .sene-cart-badge').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-count', n);
    });
  }

  /* ---------- Wiring d'une ligne ---------- */
  function wireLine(node, item) {
    var key = item.key;
    var val = node.querySelector('[data-qty-val]');
    var inc = node.querySelector('[data-qty-inc]');
    var dec = node.querySelector('[data-qty-dec]');
    var del = node.querySelector('[data-item-del]');
    var confirm = node.querySelector('[data-item-confirm]');
    var cancel = node.querySelector('[data-confirm-cancel]');
    var remove = node.querySelector('[data-confirm-remove]');

    /* Clics rapides +/− : maj optimiste immédiate de l'affichage, puis UNE
       seule requête envoyée après 350 ms d'inactivité (anti-rebond). Les
       réponses obsolètes sont ignorées grâce à qtySeq — corrige le bug
       « undefined article ». */
    var qtyTimer = null;
    function setQty(q) {
      if (q < 1) q = 1;
      var from = parseInt(val.textContent, 10);
      val.textContent = q; // maj optimiste immédiate
      analytics('cart_line_qty_change', { item_id: key, from: from, to: q });
      clearTimeout(qtyTimer);
      qtyTimer = setTimeout(function () {
        var seq = ++qtySeq;
        changeLine(key, q).then(function (cart) {
          if (seq !== qtySeq) return; // une requête plus récente est partie
          safeRender(cart);
        }).catch(function () {
          if (seq !== qtySeq) return;
          getCart().then(render); // erreur (429…) → resynchronisation
        });
      }, 350);
    }
    if (inc) inc.addEventListener('click', function () { setQty(parseInt(val.textContent, 10) + 1); });
    if (dec) dec.addEventListener('click', function () { setQty(parseInt(val.textContent, 10) - 1); });

    if (del) del.addEventListener('click', function () { if (confirm) confirm.hidden = false; });
    if (cancel) cancel.addEventListener('click', function () { if (confirm) confirm.hidden = true; });
    if (remove) remove.addEventListener('click', function () {
      analytics('cart_line_remove', { item_id: key, qty: item.quantity });
      clearTimeout(qtyTimer); qtySeq++; // annule toute maj de quantité en attente
      changeLine(key, 0).then(safeRender).catch(function () { getCart().then(render); });
    });
  }

  /* ---------- Cross-sell ---------- */
  root.querySelectorAll('[data-cross-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      btn.disabled = true;
      addVariant(id, 1).then(function () {
        analytics('cart_cross_sell_add', { item_id: id, source: 'drawer' });
        return getCart();
      }).then(function (cart) { render(cart); btn.disabled = false; });
    });
  });

  /* ---------- Promo ---------- */
  (function wirePromo() {
    var toggle = root.querySelector('[data-promo-toggle]');
    var body = root.querySelector('[data-promo-body]');
    var input = root.querySelector('[data-promo-input]');
    var apply = root.querySelector('[data-promo-apply]');
    var msg = root.querySelector('[data-promo-msg]');
    if (toggle) toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      if (body) body.hidden = open;
    });
    if (apply) apply.addEventListener('click', function () {
      var code = (input.value || '').trim();
      if (!code) { showMsg(I18N.promoErrorEmpty, 'err'); return; }
      showMsg(I18N.promoChecking, '');
      fetch('/discount/' + encodeURIComponent(code), { method: 'GET', redirect: 'follow' })
        .then(getCart).then(function (cart) {
          var d = getDiscountInfo(cart);
          var ok = d.amount > 0;
          analytics('cart_promo_apply', { code: code, valid: ok });
          if (ok) {
            showMsg(t(I18N.promoApplied, { amount: money(d.amount) }), 'ok');
            render(cart);
          } else {
            // le code peut être enregistré mais ne s'appliquer qu'au checkout
            showMsg(I18N.promoSavedNotValidated, '');
          }
        }).catch(function () { showMsg(I18N.promoErrorGeneric, 'err'); });
    });
    if (input) input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); apply.click(); } });
    function showMsg(t, cls) { if (msg) { msg.textContent = t; msg.className = 'sd-promo-msg' + (cls ? ' ' + cls : ''); } }
  })();

  /* ---------- Ouverture / fermeture + focus trap ---------- */
  function open() {
    lastFocus = document.activeElement;
    root.hidden = false;
    // reflow puis classe pour transition
    void root.offsetWidth;
    root.classList.add('is-open');
    document.body.classList.add('sd-locked');
    // Affichage INSTANTANÉ depuis le cache (pas d'attente réseau perceptible),
    // puis resynchronisation silencieuse avec le serveur en arrière-plan.
    if (cachedCart) {
      render(cachedCart);
      analytics('cart_open', { items_count: cachedCart.item_count, subtotal: cachedCart.items_subtotal_price });
      getCart().then(function (cart) { if (isValidCart(cart)) render(cart); });
    } else {
      getCart().then(function (cart) { render(cart); analytics('cart_open', { items_count: cart.item_count, subtotal: cart.items_subtotal_price }); });
    }
    setTimeout(function () {
      var closeBtn = root.querySelector('[data-drawer-close]');
      if (closeBtn) closeBtn.focus();
    }, 60);
    document.addEventListener('keydown', onKey);
  }
  function close() {
    root.classList.remove('is-open');
    document.body.classList.remove('sd-locked');
    document.removeEventListener('keydown', onKey);
    setTimeout(function () { root.hidden = true; }, 400);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') trapFocus(e);
  }
  function trapFocus(e) {
    var f = panel.querySelectorAll('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])');
    var focusable = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
    if (!focusable.length) return;
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  root.querySelector('[data-drawer-close]').addEventListener('click', close);
  root.querySelector('[data-drawer-overlay]').addEventListener('click', close);

  /* ---------- Déclencheurs d'ouverture ----------
     NB : le tiroir ne s'ouvre PAS à l'ajout au panier (le pop-up natif du
     thème suffit). Il s'ouvre uniquement au survol ou au clic sur l'icône
     panier. */
  // 1) clic explicite sur un déclencheur — capture phase pour passer AVANT le
  //    JS du thème (Ella) et empêcher l'ouverture de son dropdown natif.
  //    Couvre [data-cart-drawer-open] et l'icône panier existante (.cartToggle).
  var TRIGGER_SEL = '[data-cart-drawer-open], .cartToggle, #cartToggle';
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest(TRIGGER_SEL);
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    open();
  }, true);

  // 2) Ouverture au SURVOL de l'icône panier (desktop uniquement).
  //   Petit délai anti-déclenchement accidentel ; ignoré sur écrans tactiles.
  var hoverTimer = null;
  var supportsHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (supportsHover) {
    document.addEventListener('mouseover', function (e) {
      var trigger = e.target.closest(TRIGGER_SEL);
      if (!trigger) return;
      if (root.classList.contains('is-open')) return;
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(open, 120);
    });
    // annule l'ouverture si on quitte l'icône avant le délai
    document.addEventListener('mouseout', function (e) {
      var trigger = e.target.closest(TRIGGER_SEL);
      if (!trigger) return;
      var to = e.relatedTarget;
      if (to && to.closest && to.closest(TRIGGER_SEL)) return; // toujours sur l'icône
      clearTimeout(hoverTimer);
    });
  }
  // Les formulaires d'ajout au panier et les requêtes /cart/add sont gérés
  // nativement par le thème (pop-up de confirmation) : aucune interception ici.

  // Préchargement silencieux du panier dès le chargement de la page : le
  // cache est ainsi déjà prêt à la première ouverture (plus de délai visible).
  getCart().then(cacheCart).catch(function () {});

  // API publique
  window.SeneaDrawer = { open: open, close: close, refresh: function () { return getCart().then(render); } };
})();
